import React from 'react'
import { log } from 'utils/errorLogger'
import { ErrorInlineMessage } from './ErrorInlineMessage'

interface ISectionErrorBoundaryProps extends JSX.ElementChildrenAttribute {
  section: string
}

interface ISectionErrorBoundaryState {
  error?: Error
  errorInfo?: {}
}

export class SectionErrorBoundary extends React.Component<
  ISectionErrorBoundaryProps,
  ISectionErrorBoundaryState
> {
  constructor(props: ISectionErrorBoundaryProps) {
    super(props)
    this.state = { error: undefined }
  }

  componentDidCatch(error: Error, errorInfo?: {}) {
    const { section } = this.props
    this.setState({ error })
    log('rogers', error, { extra: { ...errorInfo, section } })
  }

  render() {
    const { error } = this.state
    const { children } = this.props
    if (error) return <ErrorInlineMessage />
    return children
  }
}
